import { useRef, type ComponentProps, type HTMLAttributes } from 'react';
import type { WebTarget } from 'styled-components';

import ErrorBoundary from '../ErrorBoundary';

import { ClientCardRoot } from './ClientCard.styled';

type Props = ComponentProps<typeof ClientCardRoot> & { as?: WebTarget };

/**
 * Essentially a clickable `Card` that has slightly different styling.
 */
const ClientCard: React.FC<Props> = ({
  children,
  onClick,
  onKeyDown,
  ...rest
}) => {
  const ref = useRef<HTMLElement>(null);

  const clickProps: HTMLAttributes<HTMLElement> = onClick
    ? {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: e => {
          onKeyDown?.(e);

          if (e.isDefaultPrevented()) return;

          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
            e.preventDefault();
            ref.current?.click();
          }
        },
      }
    : { onKeyDown };

  return (
    <ClientCardRoot ref={ref} {...clickProps} {...rest}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </ClientCardRoot>
  );
};

export default ClientCard;
